import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { Modal } from 'react-bootstrap';
import actionsFunc from 'components/actions';

const { toggleModal } = actionsFunc;
const MODAL_NAME = 'ConfirmModal';

class ConfirmModal extends Component {
  static MODAL_NAME = MODAL_NAME;
  static propTypes = {
    modalType: PropTypes.string,
    modalName: PropTypes.string,
    show: PropTypes.bool,
    title: PropTypes.string,
    actions: PropTypes.func,
    text: PropTypes.string,
    hideOk: PropTypes.bool,
    hideCancel: PropTypes.bool,
    message: PropTypes.string,
    cancelFunc: PropTypes.func,
    okFunc: PropTypes.func,
    cancelText: PropTypes.string,
    okText: PropTypes.string,
    okClass: PropTypes.string,
    cancelClass: PropTypes.string
  };

  constructor(props) {
    super(props);
  }

  closeModal = () => {
    if (this.props.cancelFunc) {
      this.props.cancelFunc();
    }

    this.props.actions.toggleModal({ modalName: '', ActiveModal: null });
  };

  render() {
    const { title, message, hideCancel, hideOk } = this.props;

    return (
      <Modal show={this.props.show} onHide={this.closeModal} backdrop='static' keyboard={false} container={this} id='confirm-modal'
        style={{marginTop: '15%'}}>
        {
          title && title.length > 0 &&
            (
              <Modal.Header>
                <Modal.Title id='contained-modal-title-lg'>{title}</Modal.Title>
                <button className='close' onClick={() => { this.closeModal(); }}>
                  <i className='icon-icn_close' />
                </button>
              </Modal.Header>
            )
        }
        <Modal.Body>
          <div>{message}</div>
        </Modal.Body>
        <Modal.Footer>
          <div style={{float: 'left'}}>
            {
              !hideCancel &&
              <button type='button' className={this.props.cancelClass || 'btn btn-primary btn-siteone-default'} onClick={this.closeModal} style={{ marginRight: 10 }}>
                {this.props.cancelText || 'Cancel'}
              </button>
            }
            {
              !hideOk &&
              <button type='button' className={this.props.okClass || 'btn btn-primary btn-siteone'} onClick={this.props.okFunc}>
                {this.props.okText || 'Yes'}
              </button>
            }
          </div>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      toggleModal
    },
    dispatch
  )
});

export default connect(null, mapDispatchToProps)(ConfirmModal);



// WEBPACK FOOTER //
// ./src/components/ConfirmModal/index.js